<template>
  <div>
    <carousel
    v-if="post.attachment_full_path"
      class="owl-carousel-customized-10"
      :nav="false"
      :dots="true"
      :responsive="{
        0: { items: 1 },
        600: { items: 1 },
        1000: { items: 1 },
      }"
    >
      <div class="item" v-for="(attach,index) in post.attachment_full_path" :key="index">
        <div
          class="con-post-img"
          v-if="post.attachment"
          v-bind:style="{
            background: `url( ${attach}) no-repeat center center `,
          }"
        >
          <!-- <img :src="post.attachment_full_path" alt="" /> -->
        </div>
      </div>
    </carousel>

    <div class="con-post-content con-post-content-Poll">
      <h1>{{ post.body }}</h1>
    </div>
    <post-tags :post="post"></post-tags>
  </div>
</template>
<script>
import PostTags from "../PostTags.vue";
import carousel from "vue-owl-carousel";
// import { mapActions } from "vuex";
export default {
  components: { PostTags, carousel },
  name: "NormalPost",
  props: {
    post: Object,
  },

  // methods: {
  //   ...mapActions("post", ["likePostApi", "disLikePostApi", "savePostApi"]),
  //   likePost(post, event) {
  //     this.likePostApi(post._id).then(() => {
  //       if (post.is_disliked_by_student == 1) {
  //         post["is_disliked_by_student"] = 0;
  //       }

  //       if (event.target.classList.contains("likePost")) {
  //         event.target.classList.remove("likePost");
  //         post["is_liked_by_student"] = 0;
  //         post["likes_count"] = post["likes_count"] - 1;
  //       } else {
  //         event.target.classList.add("likePost");
  //         post["is_liked_by_student"] = 1;
  //         post["likes_count"] = post["likes_count"] + 1;
  //       }
  //     });
  //   },
  //   disLikePost(post, event) {
  //     this.disLikePostApi(post._id).then(() => {
  //       if (post.is_liked_by_student == 1) {
  //         post["is_liked_by_student"] = 0;
  //       }

  //       if (event.target.closest("svg").classList.contains("dislikePost")) {
  //         event.target.closest("svg").classList.remove("dislikePost");
  //         post["is_disliked_by_student"] = 0;
  //       } else {
  //         event.target.closest("svg").classList.add("dislikePost");
  //         post["is_disliked_by_student"] = 1;
  //         post["likes_count"] = post["likes_count"]
  //           ? post["likes_count"] - 1
  //           : 0;
  //       }
  //     });
  //   },
  //   savePost(post, event) {
  //     this.savePostApi(post._id).then(() => {
  //       if (post.is_saved_by_student == 1) {
  //         post["is_saved_by_student"] = 0;
  //       }

  //       if (event.target.classList.contains("savePost")) {
  //         event.target.classList.remove("savePost");
  //         post["is_saved_by_student"] = 0;
  //         post["saves_count"] = post["saves_count"] - 1;
  //       } else {
  //         event.target.classList.add("savePost");
  //         post["is_saved_by_student"] = 1;
  //         post["saves_count"] = post["saves_count"] + 1;
  //       }
  //     });
  //   },
  // },
};
</script>
<style scoped>
.con-post-content{
  padding-top: 5px;
}
</style>